import React from "react";
import Grid from "@material-ui/core/Grid";
import PersonIcon from "@material-ui/icons/Person";

export default function PageHead(props) {
  const { title, icon, profile } = props;
  return (
    <div>
      <Grid container>
        <Grid xs={12} sm={6} item>
          <h1 className="pageTitle">
            <div
              style={{
                float: "left",
                paddingTop: "5px",
                marginRight: "15px",
              }}
            >
              {icon}
            </div>
            <div style={{ float: "none" }}>{title}</div>
          </h1>
        </Grid>
        <Grid xs={12} sm={6} align="right" item>
          <h1 className="pageTitle" style={{ textAlign: "right" }}>
            <div style={{ float: "right" }}>
              {profile.NameTha} {profile.SurNameTha}
            </div>
            <div
              style={{
                float: "right",
                paddingTop: "5px",
                marginRight: "15px",
              }}
            >
              <PersonIcon style={{ fontSize: "2rem" }} />
            </div>
          </h1>
        </Grid>
      </Grid>
    </div>
  );
}
